import React from 'react';
import { useTranslation } from 'react-i18next';

import Cta from 'component/Layout/Cta';
import { CtaTheme } from 'component/Layout/Cta/types';

import { useLinkTarget } from 'hooks/useLinkTarget';

import { replaceParamListInUrl } from 'utility/Provide/Url';
import { trackGa4Event } from 'utility/Track/trackingHelper';

import { Product, Source } from 'types/common';

import { Group as GroupModel } from 'proto/Community/Group';

import { TrackingEvent } from '../types';

import AvatarList from './__partials/AvatarList';

import styles from './Group.module.scss';

export interface GroupProps {
    groupModel: GroupModel;
    source: Source;
}

const Group = ({ groupModel, source }: GroupProps) => {
    const { t } = useTranslation();
    const linkTarget = useLinkTarget();
    const { imageUrl, description, name, avatarList, ctaUrl, ctaText } =
        groupModel;
    const link = replaceParamListInUrl(ctaUrl, [
        { key: 'product', value: Product.Package },
        { key: 'source', value: source },
    ]);

    return (
        <div className={styles.Group} title={`${name}, ${description}`}>
            <div className={styles.Image}>
                <img src={imageUrl} alt={description} />
            </div>
            <div className={styles.Name}>{name}</div>
            <div className={styles.Description}>{description}</div>
            <AvatarList avatarList={avatarList} />
            <Cta
                customClassList={{
                    Cta: styles.Cta,
                }}
                linkTarget={linkTarget}
                theme={CtaTheme.TERTIARY}
            >
                {ctaText || t('TRANS-look-at')}
            </Cta>
            <a
                onClick={() =>
                    trackGa4Event(TrackingEvent, {
                        click_target: name,
                    })
                }
                rel="noreferrer"
                target={linkTarget}
                className={styles.AreaLink}
                href={link}
                aria-label={name}
            />
        </div>
    );
};

export default Group;
